import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarEngineTypes,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import { OptionType } from '@/typings/common';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';

import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '../../../../../../../common.styles';

function EngineTypeFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedEngineTypes =
    useTypedSelector(getSelectedFilters).selectedParams.selectedEngineType;
  const [isOpened, setOpened] = useState(false);

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const engineTypeOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'fuelTypes'
  );

  const handleChangeEngineType = (engineType: OptionType) => {
    dispatch(
      setCarEngineTypes(
        handleChangeMultiSelect(engineType, selectedEngineTypes)
      )
    );
    dispatch(setPage(1));
  };

  const handleClearEngineType = () => {
    dispatch(setCarEngineTypes([]));
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Двигатель"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterMultiSelect
          options={engineTypeOptions}
          selectedOptions={selectedEngineTypes}
          onChange={handleChangeEngineType}
          onClear={handleClearEngineType}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default EngineTypeFilter;
